import { useSearchParams } from 'next/navigation';
import React from 'react';

import { configs } from '@/configs';
import useCreateQueryString from '@/hooks/useCreateQueryString';
import { isJSON } from '@/utils';

const isProduction = configs.ssoCallback === 'https://airight.io';
const KEY_TAG_EVENT_PROD = 368;
const KEY_TAG_EVENT_DEV = 89;
const LIST = [
  {
    id: isProduction ? KEY_TAG_EVENT_PROD : KEY_TAG_EVENT_DEV,
    content: 'christmas',
  },
  {
    id: isProduction ? 270 : 35,
    content: 'anime',
  },
  {
    id: isProduction ? 1281 : 49,
    content: 'realistic',
  },
  {
    id: isProduction ? 1280 : 91,
    content: 'comics',
  },
  {
    id: isProduction ? 1279 : 90,
    content: 'printing',
  },
  {
    id: isProduction ? 171 : 92,
    content: 'logo',
  },
  {
    id: isProduction ? 1282 : 94,
    content: 'food',
  },
  // {
  //   id: isProduction ? 1283 : 95,
  //   content: 'nsfw',
  // },
  {
    id: isProduction ? 260 : 93,
    content: 'spiritual',
  },
  {
    id: isProduction ? 39 : 55,
    content: 'landscape',
  },
  {
    id: isProduction ? 1284 : 48,
    content: 'architecture',
  },
];

const LIST_TAG_EVENT_PROD = [368, 570, 1309, 1312];

const HotTags: React.FC = () => {
  const searchParams = useSearchParams();
  const createQueryString = useCreateQueryString();
  const paramTags = searchParams.get('tagIds') ?? '';
  const currentTags: Array<number> = isJSON(paramTags) ? JSON.parse(paramTags) : [];

  const isTagSelected = (id: number) => currentTags.includes(id);
  const isEventTagProd = (id: number) => id === KEY_TAG_EVENT_PROD && isProduction;

  const onClickTag = (id: number) => {
    if (isTagSelected(id)) {
      const inputTagIds = isEventTagProd(id)
        ? currentTags.filter((tag) => !LIST_TAG_EVENT_PROD.includes(tag))
        : currentTags.filter((tag) => tag !== id);
      createQueryString('tagIds', JSON.stringify(inputTagIds));
    } else {
      const inputTagIds = isEventTagProd(id)
        ? currentTags.concat(LIST_TAG_EVENT_PROD)
        : currentTags.concat([id]);
      createQueryString('tagIds', JSON.stringify(inputTagIds));
    }
  };

  return (
    <div className="mt-3 flex flex-wrap items-center">
      {LIST.map((tag) => (
        <div
          onClick={() => onClickTag(tag.id)}
          className="mb-2 mr-2 cursor-pointer hover:opacity-70"
          key={tag.id}
        >
          <div
            aria-checked={isTagSelected(tag.id)}
            className="rounded-[100px] border-1 border-gray-100 px-[14px] py-[6px] text-[14px] lowercase text-black aria-checked:border-black"
          >
            {tag.content}
          </div>
        </div>
      ))}
    </div>
  );
};

export default HotTags;
